import { Col, Row, Divider, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { CONST } from '../../../constants/constant';
import InputComponent from '../../common/InputComponent/InputComponent';

const QuotationHeaderPDF = ({ form }) => {
  const { t } = useTranslation();
  const getValue = field => {
    const value = form.getFieldValue(field);
    return value ? value : '';
  };
  return (
    <div className="bg-white rounded-lg px-40 py-32 gap-24 flex flex-col">
      {/* Company and Customer Info */}
      <div className="flex flex-col self-stretch items-end justify-start gap-24">
        <div className="grid grid-cols-2 items-end self-stretch">
          <img
            src="/assets/logo/new_logo_fitta.png"
            alt=""
            className="h-48 object-contain"
          />
          <h3 className="text-headline-small font-bold text-black-medium m-0">
            {t('quotation.customerInfo', 'Thông Tin Khách Hàng')}
          </h3>
        </div>
        <div className="grid grid-cols-2 self-stretch items-start justify-end">
          <div className="grid grid-rows-5">
            <p className="flex gap-8 items-center h-32">
              <span className="text-title-small font-semibold">Địa chỉ:</span>
              <span className="text-body-large font-normal">
                {t(
                  'Constant.50 9A Street, Trung Son Residential Area, Binh Chanh, Ho Chi Minh City, Vietnam'
                )}
              </span>
            </p>
            <p className="flex gap-8 items-center h-32">
              <span className="text-title-small font-semibold">
                Điện thoại:
              </span>
              <span className="text-body-large font-normal">
                {CONST.laNhaPhone}
              </span>
            </p>
            <p className="flex gap-8 items-center h-32">
              <span className="text-title-small font-semibold">Email:</span>
              <span className="text-body-large font-normal">
                {' '}
                {CONST.laNhaEmail}
              </span>
            </p>
            <p className="flex gap-8 items-center h-32">
              <span className="text-title-small font-semibold">Website:</span>
              <span className="text-body-large font-normal">
                {CONST.laNhaWebsite}
              </span>
            </p>
            <p className="flex gap-8 items-center h-32">
              <span className="text-title-small font-semibold">
                Mã số thuế:
              </span>
              <span className="text-body-large font-normal">
                {CONST.laNhaTaxId}
              </span>
            </p>
          </div>

          <div className="grid grid-rows-4">
            <p className="flex gap-8 items-center h-32">
              <span className="text-title-small font-semibold">
                {t('quotation.customerName', 'Tên')}:
              </span>
              <span className="text-body-large font-normal">
                {getValue('customerName')}
              </span>
            </p>
            <p className="flex gap-8 items-center h-32">
              <span className="text-title-small font-semibold">
                {t('quotation.customerPhone', 'Điện thoại')}:
              </span>
              <span className="text-body-large font-normal">
                {getValue('customerPhone')}
              </span>
            </p>
            <p className="flex gap-8 items-center h-32">
              <span className="text-title-small font-semibold">
                {t('quotation.customerEmail', 'Email')}:
              </span>
              <span className="text-body-large font-normal">
                {getValue('customerEmail')}
              </span>
            </p>
            <p className="flex gap-8 items-center h-32">
              <span className="text-title-small font-semibold">
                {t('quotation.customerAddress', 'Địa chỉ')}:
              </span>
              <span className="text-body-large font-normal">
                {getValue('customerAddress')}
              </span>
            </p>
          </div>
        </div>
      </div>

      <Divider />

      {/* Title */}
      <div className="text-center">
        <h1 className="text-headline-large md:text-headline-medium font-bold text-black-high m-0 mb-2">
          {t('quotation.title', 'BÁO GIÁ NỘI THẤT')}
        </h1>
        <p className="text-black-low m-0">
          {new Date().toLocaleDateString('vi-VN', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })}
        </p>
      </div>
    </div>
  );
};

export default QuotationHeaderPDF;
